<template>
  <th>
    <div class="data-grid-column" @click.stop="onClick" :style="[widthStyle]">
      {{ title }}
      <NxSortButton
        ref="refSortButton"
        v-if="sortable"
        class="mx-1"
        v-model="localSort"
        color="light"
        size="lg"
      />
      <slot name="item" />
    </div>
  </th>
</template>

<script>
import NxSortButton from '../buttons/NxSortButton.vue'
import { useReactiveModelMixin } from '../../mixins'
import { SORT_TYPE_NONE } from '../../constants/sorts'

const reactiveSortMixin = useReactiveModelMixin(
  'sort',
  {
    type: String,
    default: SORT_TYPE_NONE,
    required: false
  },
  false)

export default {
  name: 'NxDataGridColumn',
  components: {
    NxSortButton
  },
  mixins: [
    reactiveSortMixin
  ],
  props: {
    title: {
      type: String,
      required: true
    },
    sortable: {
      type: Boolean,
      default: true,
      required: false
    },
    field: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: undefined,
      required: false
    }
  },
  computed: {
    widthStyle () {
      if (this.size) {
        return `width: ${this.size};`
      }

      return undefined
    }
  },
  watch: {
    'localSort' (value) {
      if (value && this.$parent.hasOwnProperty('handleSort')) {
        this.$parent.handleSort(this.field, value)
      }
    }
  },
  methods: {
    onClick () {
      this.$refs.refSortButton.onClick()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/datagrid/NxDataGridColumn.vue